module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.574fd0b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.woff2
// module id = 317
// module chunks = 1